import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Offcanvas from '../components/Offcanvas';
import SearchArea from '../components/SearchArea';
import BreadcrumbSection from '../components/BreadcrumbSection';

function CheckoutPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [bookingData] = useState({
    name: queryParams.get('name') || '',
    email: queryParams.get('email') || '',
    message: queryParams.get('message') || '',
    tour: {
      id: queryParams.get('tour.id') || '',
      name: queryParams.get('tour.name') || 'Unknown Tour',
      destination: queryParams.get('tour.destination') || 'Unknown Location',
      basePrice: queryParams.get('tour.basePrice') || '0.00',
      discountPrice: queryParams.get('tour.discountPrice') || null,
      days: queryParams.get('tour.days') || 0,
      nights: queryParams.get('tour.nights') || 0,
    },
  });
  const [emailSent, setEmailSent] = useState(false);
  const [bookingConfirmed, setBookingConfirmed] = useState(false);

  useEffect(() => {
    // Validate query params
    if (!bookingData.name || !bookingData.email) {
      navigate('/tour-package-details'); // Redirect if required fields are missing
    }
  }, [bookingData, navigate]);

  const handleEmailRequest = async (e) => {
    e.preventDefault();
    // Simulate email sending (replace with actual API call)
    const emailContent = `
      Subject: Tour Request for ${bookingData.tour.name}
      From: ${bookingData.name} <${bookingData.email}>
      Message: ${bookingData.message}
      Tour Details:
      - Name: ${bookingData.tour.name}
      - Destination: ${bookingData.tour.destination}
      - Base Price: $${bookingData.tour.basePrice}
      - Discount Price: $${bookingData.tour.discountPrice || 'N/A'}
      - Duration: ${bookingData.tour.days} days / ${bookingData.tour.nights} nights
    `;
    console.log('Email Content:', emailContent); // Log for debugging
    // TODO: Replace with fetch to Laravel API endpoint (e.g., POST /api/v1/send-email)
    setEmailSent(true);
    alert('Email request sent successfully! Check console for details.');
  };

  const handleBookTour = async (e) => {
    e.preventDefault();
    // Simulate booking (replace with actual API call)
    const bookingContent = {
      userName: bookingData.name,
      email: bookingData.email,
      tourId: bookingData.tour.id,
      message: bookingData.message,
    };
    console.log('Booking Data:', bookingContent); // Log for debugging
    // TODO: Replace with fetch to Laravel API endpoint (e.g., POST /api/v1/book-tour)
    setBookingConfirmed(true);
    alert('Tour booked successfully! Check console for details.');
  };

  return (
    <>
      <Offcanvas />
      <SearchArea />
      <Header />
      <BreadcrumbSection title="Checkout" />
      <section className="checkout-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Checkout for {bookingData.tour.name}</h2>
              <div className="checkout-details">
                <h3>Tour Details</h3>
                <p><strong>Destination:</strong> {bookingData.tour.destination}</p>
                <p><strong>Duration:</strong> {bookingData.tour.days} days / {bookingData.tour.nights} nights</p>
                <p><strong>Base Price:</strong> ${bookingData.tour.basePrice}</p>
                {bookingData.tour.discountPrice && (
                  <p><strong>Discount Price:</strong> ${bookingData.tour.discountPrice}</p>
                )}
                <h3>Contact Information</h3>
                <p><strong>Name:</strong> {bookingData.name}</p>
                <p><strong>Email:</strong> {bookingData.email}</p>
                <p><strong>Message:</strong> {bookingData.message}</p>
              </div>
              <div className="checkout-actions">
                {!emailSent && !bookingConfirmed && (
                  <>
                    <button onClick={handleEmailRequest} className="theme-btn">
                      Send Email Request
                      <img src="assets/img/icon/white-arrow.svg" alt="" />
                    </button>
                    <button onClick={handleBookTour} className="theme-btn ml-3">
                      Book Tour Now
                      <img src="assets/img/icon/white-arrow.svg" alt="" />
                    </button>
                  </>
                )}
                {emailSent && <p className="text-success">Email request has been sent successfully!</p>}
                {bookingConfirmed && <p className="text-success">Tour has been booked successfully!</p>}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default CheckoutPage;